export default __webpack_public_path__ + "static/media/outside2.07290b6e.jpg";